import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import Signup from './Signup';
import LawFirms from './LawFirms';
import Publishing from './Publishing';
import Healthcare from './Healthcare';
import RealEstate from './RealEstate';
import HairSalons from './HairSalons';
import Restaurants from './Restaurants';
import Other from './Other';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/enter" element={<Signup sendEmail={false} />} />
        <Route path="/industries/law-firms" element={<LawFirms />} />
        <Route path="/industries/publishing" element={<Publishing />} />
        <Route path="/industries/healthcare" element={<Healthcare />} />
        <Route path="/industries/real-estate" element={<RealEstate />} />
        <Route path="/industries/services" element={<HairSalons />} />
        <Route path="/industries/restaurants" element={<Restaurants />} />
        <Route path="/industries/other" element={<Other />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
